import { render, staticRenderFns } from "./FrontierRegistration.vue?vue&type=template&id=45eea918&scoped=true"
import script from "./FrontierRegistration.vue?vue&type=script&lang=js"
export * from "./FrontierRegistration.vue?vue&type=script&lang=js"
import style0 from "./FrontierRegistration.vue?vue&type=style&index=0&id=45eea918&prod&scoped=true&lang=css"
import style1 from "./FrontierRegistration.vue?vue&type=style&index=1&id=45eea918&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eea918",
  null
  
)

export default component.exports